export default __webpack_public_path__ + "static/media/logo-white-simple-shadow.12e956f8.png";